"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewInline = void 0;
var _hooks = require("../../../hooks");
var _GroupsAndClassesSelection = require("./partials/GroupsAndClassesSelection");
var _AudienceSelectorsButtons = require("./partials/AudienceSelectorsButtons");
var _jsxRuntime = require("react/jsx-runtime");
const ViewInline = props => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: isMobileView ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AudienceSelectorsButtons.AudienceSelectorsButtons, {
      ...props
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_GroupsAndClassesSelection.GroupsAndClassesSelection, {
      ...props
    })
  });
};
exports.ViewInline = ViewInline;